<script lang="ts">
    
    import { Modal, ModalHeader, ModalBody, FormGroup, Input, ModalFooter, Button, InputGroup, InputGroupText, Icon } from 'sveltestrap';
    import type { Fn } from '../global';
    import type { FormInstance } from '../Model/FormInstance';
    import type { User } from '../Model/User';
    import { formMembersFactory, instancesService, likeRegexp, sessionService, usersService } from '../Services';
    import type { FormMember } from '../Model/FormMember';

    type UserItem = {
        user: User;
        selected: boolean;
    };

    export let isOpen = false;
    export let toggle: Fn | undefined;
    export let instance: FormInstance;

    let userItems: UserItem[] = [];
    let filteredItems: UserItem[] = [];
    let searchString: string = '';

    $: if (isOpen) {
        getUsers();
    }

    $: filter(searchString);

    function updateSelection() {
        for (const userItem of userItems) {
            userItem.selected = instance.hasMember(userItem.user.id);
        }
        filteredItems = filteredItems;
    }

    async function getUsers(): Promise<void> {

        const users = await usersService.getUsers(0, 1000)
            .then(users => {
                //Dejamops en el array solo los usuarios con un rol
                // igual o superior al del usuario actual y
                // que tengan "capataz" activado
                return users.filter(({ rolId, foreman }) => {
                    return rolId >= sessionService.user.rolId && foreman;
                });
            });

        userItems = [];

        for (const user of users) {
            if (instance.hasOwner(user.id)) {
                continue;
            }
            userItems.push({
                user,
                selected: false,
            });
        }

        updateSelection();
        filter(searchString);
    }

    function filter(searchString: string): void {
        const regexp = searchString ? likeRegexp(searchString) : null;
        const filtered: UserItem[] = [];
        for (const userItem of userItems) {
            if (regexp && !regexp.test(userItem.user.name)) {
                continue;
            }
            filtered.push(userItem);
        }
        filteredItems = filtered;
    }

    async function onAccept() {
        await saveMembers();
        toggle?.();
    }

    async function saveMembers(): Promise<void> {
        const addMembers = userItems.filter(({ selected, user }) => selected && !instance.hasMember(user.id));
        const quitMembers = userItems.filter(({ selected, user }) => !selected && instance.hasMember(user.id));
        const promises: Promise<void>[] = [];

        for (const { user } of addMembers) {
            const member = formMembersFactory.createFormMember(instance, user.id);
            instance.addMember(member);
            promises.push(instancesService.addMember(instance.id, user.id));
        }

        for (const { user } of quitMembers) {
            instance.quitMember(user.id);
            promises.push(instancesService.quitMember(instance.id, user.id));
        }

        await Promise.all(promises);
        
        const members: FormMember[] = await instancesService.buddyPartner(instance)

        instance.reloadMembers(members);
    }


</script>

<Modal {isOpen} {toggle}>
    <ModalHeader {toggle}>Seleccionar miembros</ModalHeader>
    <ModalBody>

        <FormGroup>
            <InputGroup>
                <InputGroupText>
                    <Icon name="search" />
                </InputGroupText>
                <Input type="search" placeholder="Buscar usuarios" bind:value={searchString} />
            </InputGroup>
        </FormGroup>

        <ul class="list-group">
            {#each filteredItems as userItem}
            <li class="list-group-item">
                <Input
                    type="checkbox"
                    bind:checked={userItem.selected}
                    label={userItem.user.name} />
            </li>
            {/each}
        </ul>
        
    </ModalBody>
    <ModalFooter>
        <Button color="primary" on:click={onAccept}>Aceptar</Button>
    </ModalFooter>
</Modal>
